/** Legal modal keys loaded on every route (chrome bundle), not full `common` surface. */
export const LEGAL_MODAL_TRANSLATION_KEY_PREFIXES = [
  'common.privacy.',
  'common.terms.',
] as const;

/** Report error keys loaded on every route (chrome bundle). */
export const REPORTS_TRANSLATION_KEY_PREFIXES = ['common.reports.'] as const;

/** Keys with these prefixes resolve off-scope (nav chrome + legal modals + reports). */
export const GLOBAL_TRANSLATION_KEY_PREFIXES = [
  'nav.',
  ...LEGAL_MODAL_TRANSLATION_KEY_PREFIXES,
  ...REPORTS_TRANSLATION_KEY_PREFIXES,
] as const;

export function isGloballyTranslatedKey(key: string): boolean {
  return GLOBAL_TRANSLATION_KEY_PREFIXES.some((prefix) =>
    key.startsWith(prefix)
  );
}
